module.exports = __webpack_public_path__ + "fonts/NanumSquareExtraBold.5c66da61.woff2";